import React, { useState, useEffect } from "react";
import "../../scss/Navbar.css";
import CountAnimation from "../../Logic/CounterAnimation";

const Navbar = ({ data, pageName, handleTopicChange }) => {
  const { userData } = data;
  const { username, profilePic, totalNotification } = userData;
  const [placeholder_text, setPlaceholder_text] = useState("Book or Anything");

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (placeholder_text === "Book or Anything") {
        setPlaceholder_text("Search Book here...");
      } else {
        setPlaceholder_text("Book or Anything");
      }
    }, 6000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [placeholder_text]);


  return (
    <div className="Top-Navbar">
      <div className="Page-Name">
        <h3>{pageName}</h3>
      </div>
      <div className="Second-Menu">
        <div className="Search">
          <i className="far fa-search"></i>
          <input
            type="text"
            placeholder={placeholder_text}
            onChange={handleTopicChange}
          />

          <i className="fas fa-sliders-h"></i>
        </div>
      </div>
      <div className="Notification">
        <span>
          {totalNotification >= 99
            ? CountAnimation({ targetCount: 99 }) + "+"
            : CountAnimation({ targetCount: totalNotification })}
        </span>
        <i className="far fa-bell"></i>
      </div>
      <div className="User-profile">
        <img src={profilePic} alt={username} />
        <h4>{username}</h4>
        <i className="far fa-chevron-down"></i>
      </div>
    </div>
  );
};

export default Navbar;
